import 'app/libs/leafletCanvasMarkers';

import Leaflet from 'leaflet';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { MapLayer, withLeaflet } from 'react-leaflet';

class MapLeafletCanvasMarkersLayer extends MapLayer {
  static propTypes = {
    children: PropTypes.node,
    options: PropTypes.shape({}),
    onMarkerClick: PropTypes.func,
  };

  static defaultProps = {
    children: null,
    options: {},
    onMarkerClick: () => {},
  };

  createLeafletElement(props) {
    const el = Leaflet.canvasIconLayer(props.options || props);

    this.contextValue = {
      ...props.leaflet,
      layerContainer: el,
      popupContainer: el,
    };

    return el;
  }

  // eslint-disable-next-line no-unused-vars
  updateLeafletElement(fromProps, toProps) {
    // if (!fromProps.children || toProps.children) {
    //     return;
    // }
    // if (this.checkProsEqual(fromProps.children, toProps.children)) {
    //     return;
    // }

    this.leafletElement.redraw();
  }

  componentDidMount() {
    super.componentDidMount();

    this.initEventListeners(this.leafletElement);
    this.leafletElement._reset();
  }

  initEventListeners(layer) {
    layer.addOnClickListener((event, marker) => {
      this.props.onMarkerClick(event, marker);

      if (marker._popup) {
        marker._popup.setLatLng(marker._latlng).openOn(layer._map);
      }
    });
  }

  getType(ob) {
    if (ob instanceof Array) {
      return 'array';
    }

    if (typeof ob === 'object') {
      return 'object';
    }

    return typeof ob;
  }

  checkProsEqual(from, to) {
    if (!from && !to) {
      return true;
    }

    const dataKey = this.props.dataKey || 'position';

    if (
      (this.getType(from) !== 'array' && this.getType(to) !== 'object') ||
      (this.getType(from) !== 'object' && this.getType(to) !== 'array')
    ) {
      return false;
    }

    if (this.getType(from) === 'object' && this.getType(to) === 'object') {
      return isEqual(from.props[dataKey], to.props[dataKey]);
    }

    if (from.length !== to.length) {
      return false;
    }

    return !from.some((item, index) => {
      return !isEqual(item.props[dataKey], to[index].props[dataKey]);
    });
  }
}

export default withLeaflet(MapLeafletCanvasMarkersLayer);
